import { useTranslation } from 'react-i18next';
import { Arrow, CustomActionButton, DraggableContainer, Tooltip } from '../Ant';
import { ArrowSquareDown, ArrowSquareUp, QuickCalendarIcon, TransactionMailIcon } from '../icons';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { ROUTES } from '../../constants/constants';
import { useDraggableSideButton } from '../../hooks/useDraggableSideButton';
import { AnalyticsEvent, FeatureButtons } from '../../interface/analytics';
import { useAnalytics } from '../../hooks/useAnalytics';

function TransactionMailIndicator() {
  const { t } = useTranslation();
  const { push } = useNavigationStack();
  const { trackAction } = useAnalytics();

  let itemType: string | undefined;
  if (Office.context?.mailbox?.item) {
    itemType = Office.context.mailbox.item.itemType;
  }

  const isAppointment = itemType === Office.MailboxEnums.ItemType.Appointment;
  const handleNavigationToMail = () => {
    trackAction(AnalyticsEvent.BUTTON_CLICK, FeatureButtons.MAIL_ACTIONS);
    push(ROUTES.ADD_TRANSACTION_FROM_MAIL);
  };

  const { position, isDragging, dragHandlers } = useDraggableSideButton(
    'button2',
    handleNavigationToMail,
  );

  return (
    <DraggableContainer
      data-floating-action
      $position={position}
      $isDragging={isDragging}
      {...dragHandlers}
    >
      {isDragging && (
        <>
          <Arrow direction="up">
            <ArrowSquareUp />
          </Arrow>
          <Arrow direction="down">
            <ArrowSquareDown />
          </Arrow>
        </>
      )}
      <Tooltip
        title={isAppointment ? t('common:takeToCalendarActions') : t('common:takeToMailActions')}
        placement="right"
        arrow={false}
      >
        <CustomActionButton
          type="primary"
          className={isDragging ? 'shaking' : ''}
          aria-label={
            isAppointment ? t('common:takeToCalendarActions') : t('common:takeToMailActions')
          }
        >
          {isAppointment ? <QuickCalendarIcon /> : <TransactionMailIcon />}
        </CustomActionButton>
      </Tooltip>
    </DraggableContainer>
  );
}

export default TransactionMailIndicator;
